import request from '@/utils/seftRequest';

// 查询用户Centrex/CUG群组
export function qrySubsGroupInfoBsnl(params) {
  return request('/ding/subsService/qrySubsGroupInfoBsnl', {
    params,
  });
}

// 查询用户Call Hunting群组
export function qrySubsCallHuntingNbrBsnl(params) {
  return request('/ding/subsService/qrySubsCallHuntingNbrBsnl', {
    params,
  });
}

// 查询FMC对应的fellowNbrType列表
export function qryFellowNbrType4FMCBsnl() {
  return request('/ding/subsService/qryFellowNbrType4FMCBsnl');
}

// 查询FNF的fellowNbrType
export function qryFellowNbrType4FNFBsnl() {
  return request('/ding/subsService/qryFellowNbrType4FNFBsnl');
}

// 查询订户下fellowNbr列表，可查询FMC/FNF
export function qryFellowNbrBsnl(params) {
  return request('/ding/subsService/qryFellowNbrBsnl', {
    params,
  });
}

// 修改vas, 修改FMC/FNF列表
export function setVasBsnl(params) {
  return request('/ding/subsService/setVasBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询可订购的VAS
export function qryAvailableRelateOfferBsnl(params) {
  return request('/ding/subsService/qryAvailableRelateOfferBsnl', {
    method: 'POST',
    body: params,
  });
}

// 变更Centrex/CUG群组
export function manageSubsGroupInfoBsnl(params) {
  return request('/ding/subsService/manageSubsGroupInfoBsnl', {
    method: 'POST',
    body: params,
  });
}

// 变更Call Hunting群组
export function manageSubsCallHuntingNbrBsnl(params) {
  return request('/ding/subsService/manageSubsCallHuntingNbrBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询属性信息接口
export function qryAttrInfoBsnl(params) {
  return request('/ding/custService/qryAttrInfoBsnl', { params });
}
